<template>
  <div>
    <GoogleMapLoader :mapConfig="mapConfig">
      <template slot-scope="{ google, map }">
        <GoogleMapMarker
          :marker="computedMarker"
          :google="google"
          :map="map"
          v-on:marker-moved="markerMoved"
        />
        <GoogleMapCircle :circle="computedMarker" :google="google" :map="map" />
      </template>
    </GoogleMapLoader>
  </div>
</template>

<script>
import GoogleMapLoader from "@/components/GoogleMapLoader.vue";
import GoogleMapMarker from "@/components/GoogleMapMarker.vue";
import GoogleMapCircle from "@/components/GoogleMapCircle.vue";
import { mapSettings } from "@/constants/mapSettings.js";

export default {
  name: "GoogleMap",
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapCircle
  },
  props: {
    marker: Object
  },
  data() {
    return {
      componentKey: 0,
      localMarker: this.marker
    };
  },
  methods: {
    markerMoved(val) {
      this.$emit("marker-moved", val);
    }
  },
  computed: {
    mapConfig() {
      return {
        ...mapSettings
        //center: { lat: this.marker.position.lat, lng: this.marker.position.lng }
      };
    },
    computedMarker() {
      console.log(this.marker.position);
      console.log(this.marker.radius);
      return this.marker;
    }
  }
};
</script>
